module.exports = __webpack_public_path__ + "blackflame.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blackflame.png
// module id = 852
// module chunks = 0